/* =========================================================================
   Wishwick theme — header, snow, reveal, cart drawer (Shopify Ajax API),
   product page (gallery, bundles, add-ons, sticky buy box & bar)
   ========================================================================= */
(function () {
  const T = window.theme || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  /* ---------------- Money (uses the store's own money format) ---------------- */
  function formatMoney(cents) {
    const format = T.moneyFormat || "${{amount}}";
    const n = (Number(cents) || 0) / 100;
    const fmt = (dec, thou, sep) => {
      const [i, d] = n.toFixed(dec).split(".");
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? sep + d : "");
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: fmt(2, ",", "."),
      amount_no_decimals: fmt(0, ",", "."),
      amount_with_comma_separator: fmt(2, ".", ","),
      amount_no_decimals_with_comma_separator: fmt(0, ".", ","),
      amount_with_apostrophe_separator: fmt(2, "'", "."),
      amount_with_space_separator: fmt(2, " ", ","),
    }[key] || fmt(2, ",", ".")));
  }
  const pctOff = (price, compare) => Math.round((1 - price / compare) * 100);

  /* ---------------- Header ---------------- */
  const header = $(".site-header");
  if (header && !header.classList.contains("always-solid")) {
    const onScroll = () => header.classList.toggle("is-solid", scrollY > 40);
    addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }
  const menuBtn = $(".menu-toggle");
  const nav = $(".nav");
  if (menuBtn && nav) {
    menuBtn.addEventListener("click", () => {
      const open = nav.classList.toggle("open");
      menuBtn.setAttribute("aria-expanded", open);
    });
    $$("a", nav).forEach((a) => a.addEventListener("click", () => nav.classList.remove("open")));
  }

  /* ---------------- Hero video: fade in once it actually plays ---------------- */
  const heroVideo = $(".hero-video video");
  if (heroVideo) {
    if (reducedMotion) heroVideo.remove();
    else {
      // Autoplay can start before this deferred script runs, so check the
      // current state as well as listening for later events.
      const markPlaying = () => heroVideo.classList.add("playing");
      heroVideo.muted = true;
      heroVideo.addEventListener("playing", markPlaying);
      heroVideo.addEventListener("timeupdate", markPlaying, { once: true });
      if (!heroVideo.paused && heroVideo.readyState > 2) markPlaying();
      heroVideo.play().then(markPlaying).catch(() => {});
    }
  }

  /* ---------------- Snowfall ---------------- */
  const canvas = $("#snow");
  if (canvas && !reducedMotion) {
    const ctx = canvas.getContext("2d");
    let flakes = [], w, h, dpr;
    const resize = () => {
      dpr = Math.min(devicePixelRatio || 1, 2);
      w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const count = Math.round(Math.min(160, (w * h) / 9000));
      flakes = Array.from({ length: count }, () => ({
        x: Math.random() * w, y: Math.random() * h,
        r: Math.random() * 1.8 + 0.4, s: Math.random() * 0.5 + 0.25,
        d: Math.random() * Math.PI * 2, o: Math.random() * 0.5 + 0.3,
      }));
    };
    let visible = true;
    new IntersectionObserver(([e]) => (visible = e.isIntersecting)).observe(canvas);
    const tick = () => {
      if (visible) {
        ctx.clearRect(0, 0, w, h);
        for (const f of flakes) {
          f.d += 0.01; f.y += f.s; f.x += Math.sin(f.d) * 0.35;
          if (f.y > h + 4) { f.y = -4; f.x = Math.random() * w; }
          ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(255, 248, 235, ${f.o})`; ctx.fill();
        }
      }
      requestAnimationFrame(tick);
    };
    resize(); addEventListener("resize", resize); tick();
  }

  /* ---------------- Reveal on scroll + parallax ---------------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
  $$(".reveal").forEach((el) => io.observe(el));
  // In the theme editor, show everything immediately so merchants can edit it.
  if (window.Shopify && window.Shopify.designMode) $$(".reveal").forEach((el) => el.classList.add("in"));

  const para = $$("[data-parallax]");
  if (para.length && !reducedMotion) {
    const update = () => para.forEach((el) => {
      const r = el.parentElement.getBoundingClientRect();
      const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
      el.style.transform = `translate3d(0, ${p * -60}px, 0)`;
    });
    addEventListener("scroll", update, { passive: true }); update();
  }

  /* =========================================================================
     CART (Shopify Ajax API)
     ========================================================================= */
  const routes = T.routes || { cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change", root: "/" };
  const json = (r) => { if (!r.ok) return r.json().then((e) => Promise.reject(e)); return r.json(); };
  const CartAPI = {
    get: () => fetch(`${routes.cart}.js`, { headers: { Accept: "application/json" } }).then(json),
    add: (items) => fetch(`${routes.cartAdd}.js`, {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items }),
    }).then(json),
    change: (key, quantity) => fetch(`${routes.cartChange}.js`, {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    }).then(json),
  };

  /* compare-at prices aren't in /cart.js, so look them up per product (cached) */
  const compareCache = {};
  async function compareAtFor(item) {
    if (!item.handle) return 0;
    if (!compareCache[item.handle]) {
      compareCache[item.handle] = fetch(`${routes.root.replace(/\/$/, "")}/products/${item.handle}.js`)
        .then(json).catch(() => ({ variants: [] }));
    }
    const p = await compareCache[item.handle];
    const v = (p.variants || []).find((x) => x.id === item.variant_id);
    return v && v.compare_at_price > item.final_price ? v.compare_at_price : 0;
  }

  const drawer = $("#cart-drawer");
  const overlay = $(".drawer-overlay");
  let cartState = null;
  let lastFocus = null;

  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add("open"); overlay.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    setTimeout(() => $("[data-close-cart].icon-btn", drawer)?.focus({ preventScroll: true }), 50);
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("open"); overlay.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    lastFocus?.focus?.({ preventScroll: true });
  }
  window.openCart = openCart;
  $$("[data-close-cart]").forEach((b) => b.addEventListener("click", closeCart));
  if (T.template !== "cart") {
    $$("[data-open-cart]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); openCart(); }));
  }
  addEventListener("keydown", (e) => { if (e.key === "Escape" && drawer?.classList.contains("open")) closeCart(); });

  /* optional reservation countdown (theme setting, off by default) */
  let reserveTimer = null;
  function startReserve() {
    const el = $("[data-reserve]");
    if (!el || !T.cart?.reserveTimer) return;
    const mins = T.cart.reserveMinutes || 10;
    let until;
    try { until = +sessionStorage.getItem("ww_reserve") || 0; } catch { until = 0; }
    const reset = () => { until = Date.now() + mins * 60000; try { sessionStorage.setItem("ww_reserve", until); } catch {} };
    if (!until || until < Date.now()) reset();
    el.hidden = false;
    clearInterval(reserveTimer);
    const draw = () => {
      let left = until - Date.now();
      if (left <= 0) { reset(); left = until - Date.now(); }
      const m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      $("[data-reserve-time]").textContent = `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    };
    draw(); reserveTimer = setInterval(draw, 1000);
  }

  async function renderCart(cart) {
    cartState = cart;
    dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
    const count = cart.item_count;
    $$(".cart-count").forEach((el) => {
      const prev = el.textContent.trim();
      el.textContent = count;
      el.classList.toggle("has-items", count > 0);
      if (prev !== String(count) && count > 0) { el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); }
    });
    if (!drawer) return;

    const body = $("[data-cart-body]");
    $("[data-cart-items]").textContent = count ? `(${count})` : "";
    $("[data-cart-foot]").hidden = !count;
    $("[data-ship]").hidden = !count;

    if (!count) {
      const reserve = $("[data-reserve]"); if (reserve) reserve.hidden = true;
      clearInterval(reserveTimer);
      body.innerHTML = $("#cart-empty-template")?.innerHTML || "";
      return;
    }
    startReserve();

    const compares = await Promise.all(cart.items.map(compareAtFor));
    let compareTotal = 0;
    const lines = cart.items.map((item, i) => {
      const unitCompare = compares[i];
      const lineCompare = unitCompare ? unitCompare * item.quantity : item.original_line_price;
      compareTotal += Math.max(lineCompare, item.final_line_price);
      const variantTitle = item.product_has_only_default_variant ? "" : item.variant_title;
      const upsellIcon = (T.cart?.upsells || []).find((u) => u.variantId === item.variant_id)?.icon;
      const img = item.image
        ? `<img src="${esc(item.image + (item.image.includes("?") ? "&" : "?") + "width=200")}" alt="" loading="lazy">`
        : `<span class="icon-thumb" aria-hidden="true">${esc(upsellIcon || "✦")}</span>`;
      return `
        <div class="line">
          <a href="${esc(item.url)}">${img}</a>
          <div>
            <div class="line-title">${esc(item.product_title)}</div>
            ${variantTitle ? `<div class="line-note">${esc(variantTitle)}</div>` : ""}
            <div class="line-qty">
              <button data-qty-key="${esc(item.key)}" data-qty-to="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button data-qty-key="${esc(item.key)}" data-qty-to="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
          </div>
          <div class="line-right">
            <div>
              <strong>${formatMoney(item.final_line_price)}</strong>
              ${lineCompare > item.final_line_price ? `<s>${formatMoney(lineCompare)}</s>` : ""}
            </div>
            <button class="line-remove" data-qty-key="${esc(item.key)}" data-qty-to="0">Remove</button>
          </div>
        </div>`;
    }).join("");

    const inCart = new Set(cart.items.map((i) => i.variant_id));
    const upsells = (T.cart?.upsells || []).filter((u) => !inCart.has(u.variantId));
    const upsellHtml = upsells.length ? `
      <div class="upsell">
        <h3>Make it extra special</h3>
        ${upsells.map((u) => `
          <div class="upsell-item">
            ${u.icon ? `<span class="icon-thumb sm" aria-hidden="true">${esc(u.icon)}</span>` : (u.image ? `<img src="${esc(u.image)}" alt="">` : "")}
            <div>${esc(u.title)}<span>${formatMoney(u.price)}</span></div>
            <button data-upsell="${u.variantId}">Add</button>
          </div>`).join("")}
      </div>` : "";

    body.innerHTML = lines + upsellHtml;

    const savings = compareTotal - cart.total_price;
    $("[data-cart-subtotal]").textContent = formatMoney(cart.total_price);
    $("[data-savings-row]").hidden = savings <= 0;
    $("[data-cart-savings]").textContent = `−${formatMoney(savings)}`;

    const th = T.cart?.freeShippingThreshold || 0;
    const shipText = $("[data-ship-text]");
    if (!th || cart.total_price >= th) {
      shipText.innerHTML = "🎄 You've unlocked <strong>free shipping</strong>";
      $("[data-ship-bar]").style.width = "100%";
    } else {
      shipText.innerHTML = `You're ${formatMoney(th - cart.total_price)} away from <strong>free shipping</strong>`;
      $("[data-ship-bar]").style.width = `${(cart.total_price / th) * 100}%`;
    }
  }

  function toast(msg) {
    const el = $(".toast"); if (!el) return;
    el.textContent = msg; el.classList.add("show");
    clearTimeout(toast.t); toast.t = setTimeout(() => el.classList.remove("show"), 2600);
  }

  async function refreshCart() {
    try { await renderCart(await CartAPI.get()); } catch (e) { console.error("[cart]", e); }
  }

  async function addToCart(items) {
    try {
      await CartAPI.add(items);
      await refreshCart();
      openCart();
      return true;
    } catch (err) {
      toast(err?.description || err?.message || "Couldn't add to cart. Please try again.");
      return false;
    }
  }
  window.addToCart = addToCart;

  if (drawer) {
    $("[data-cart-body]").addEventListener("click", async (e) => {
      const btn = e.target.closest("button"); if (!btn) return;
      btn.disabled = true;
      try {
        if (btn.dataset.qtyKey) await renderCart(await CartAPI.change(btn.dataset.qtyKey, Math.max(0, +btn.dataset.qtyTo)));
        if (btn.dataset.upsell) { await CartAPI.add([{ id: +btn.dataset.upsell, quantity: 1 }]); await refreshCart(); }
      } catch (err) {
        toast(err?.description || "Something went wrong. Please try again.");
        refreshCart();
      }
    });
  }
  refreshCart();

  /* quick-add buttons anywhere on the site */
  $$("[data-quick-add]").forEach((btn) => btn.addEventListener("click", async () => {
    btn.setAttribute("aria-busy", "true");
    await addToCart([{ id: +btn.dataset.quickAdd, quantity: 1 }]);
    btn.removeAttribute("aria-busy");
  }));

  /* =========================================================================
     PRODUCT PAGE
     ========================================================================= */
  const pdp = $("[data-pdp]");
  if (!pdp) return;

  const product = JSON.parse($("[data-product-json]")?.textContent || '{"variants":[]}');
  const form = $("#product-form");
  const variantInput = $("[data-variant-input]");
  let selected = product.variants.find((v) => v.id === +variantInput?.value) || product.variants[0];
  let qty = 1;

  /* gallery */
  const frame = $(".gallery-main", pdp);
  const slides = $$("[data-slide]", pdp);
  const thumbs = $("[data-thumbs]", pdp);
  const backdrop = $("[data-gallery-backdrop]", pdp);
  let gIndex = 0;
  function showSlide(i) {
    if (!slides.length) return;
    gIndex = (i + slides.length) % slides.length;
    slides.forEach((s, j) => {
      const active = j === gIndex;
      s.classList.toggle("active", active);
      const v = $("video", s);
      if (v) { if (active && !reducedMotion) { v.muted = true; v.play().catch(() => {}); } else v.pause(); }
    });
    if (backdrop && slides[gIndex].dataset.backdrop) backdrop.style.backgroundImage = `url("${slides[gIndex].dataset.backdrop}")`;
    if (thumbs) $$("button", thumbs).forEach((b, j) => b.classList.toggle("active", j === gIndex));
  }
  thumbs?.addEventListener("click", (e) => { const b = e.target.closest("button"); if (b) showSlide(+b.dataset.i); });
  $("[data-gallery-prev]", pdp)?.addEventListener("click", () => showSlide(gIndex - 1));
  $("[data-gallery-next]", pdp)?.addEventListener("click", () => showSlide(gIndex + 1));
  let touchX = null;
  frame?.addEventListener("touchstart", (e) => (touchX = e.touches[0].clientX), { passive: true });
  frame?.addEventListener("touchend", (e) => {
    if (touchX == null) return;
    const dx = e.changedTouches[0].clientX - touchX;
    if (Math.abs(dx) > 40) showSlide(gIndex + (dx < 0 ? 1 : -1));
    touchX = null;
  });
  showSlide(0);

  /* bundles (variants) */
  const bundlesEl = $("[data-bundles]", pdp);
  const stickySelect = $("[data-sticky-select]");
  bundlesEl?.addEventListener("change", (e) => { if (e.target.name === "bundle") selectVariant(+e.target.value); });
  stickySelect?.addEventListener("change", () => selectVariant(+stickySelect.value));

  function selectVariant(id) {
    selected = product.variants.find((v) => v.id === id) || selected;
    if (variantInput) variantInput.value = selected.id;
    const radio = bundlesEl && $(`input[name="bundle"][value="${selected.id}"]`, bundlesEl);
    if (radio) radio.checked = true;
    if (stickySelect) stickySelect.value = selected.id;
    const url = new URL(location.href);
    url.searchParams.set("variant", selected.id);
    history.replaceState(null, "", url);
    renderPrice();
  }
  function renderPrice() {
    const onSale = selected.compare_at_price > selected.price;
    // checked add-ons count toward the displayed total
    const addons = $$("[data-addons] input:checked", pdp).reduce((s, cb) => s + (+cb.dataset.addonPrice || 0), 0);
    $$("[data-price]").forEach((el) => (el.textContent = formatMoney(selected.price * qty + addons)));
    $$("[data-compare]").forEach((el) => { el.hidden = !onSale; el.textContent = formatMoney(selected.compare_at_price * qty + addons); });
    $$("[data-save]").forEach((el) => { el.hidden = !onSale; el.textContent = onSale ? `Save ${pctOff(selected.price, selected.compare_at_price)}%` : ""; });
    $$("[data-sticky-variant]").forEach((el) => (el.textContent = selected.title));
    $$("[data-atc]").forEach((b) => {
      b.disabled = !selected.available;
      const label = $(".btn-label", b);
      if (label && !selected.available) label.textContent = "Sold out";
      else if (label && label.textContent === "Sold out") label.textContent = "Add to cart";
    });
  }

  $("[data-addons]", pdp)?.addEventListener("change", renderPrice);
  /* keep add-on checkboxes in sync when an add-on is removed from the cart drawer */
  addEventListener("cart:updated", (e) => {
    const inCart = new Set(e.detail.items.map((i) => i.variant_id));
    let changed = false;
    $$("[data-addons] input:checked", pdp).forEach((cb) => {
      if (cb.dataset.wasInCart && !inCart.has(+cb.value)) { cb.checked = false; changed = true; }
      cb.dataset.wasInCart = inCart.has(+cb.value) ? "1" : "";
    });
    if (changed) renderPrice();
  });

  /* quantity */
  const qtyInput = $("[data-qty]", pdp);
  const setQty = (n) => { qty = Math.max(1, Math.min(10, n || 1)); if (qtyInput) qtyInput.value = qty; renderPrice(); };
  $("[data-qty-dec]", pdp)?.addEventListener("click", () => setQty(qty - 1));
  $("[data-qty-inc]", pdp)?.addEventListener("click", () => setQty(qty + 1));
  qtyInput?.addEventListener("change", () => setQty(parseInt(qtyInput.value, 10)));

  /* add to cart: main button, sticky bar and the wand section share this */
  async function addSelected(btn) {
    const btns = $$("[data-atc]");
    btns.forEach((b) => b.setAttribute("aria-busy", "true"));
    const items = [{ id: selected.id, quantity: qty }];
    const inCart = new Set((cartState?.items || []).map((i) => i.variant_id));
    $$("[data-addons] input:checked", pdp).forEach((cb) => {
      if (!inCart.has(+cb.value)) items.push({ id: +cb.value, quantity: 1 });
    });
    const ok = await addToCart(items);
    btns.forEach((b) => b.removeAttribute("aria-busy"));
    if (ok && btn) { btn.classList.add("added"); setTimeout(() => btn.classList.remove("added"), 1800); }
  }
  form?.addEventListener("submit", (e) => { e.preventDefault(); addSelected($("#atc-main")); });
  $$("[data-atc]").forEach((b) => { if (b.type !== "submit") b.addEventListener("click", () => addSelected(b)); });


  /* sticky buy box: if taller than the viewport, stick by its bottom edge */
  const buybox = $(".buybox", pdp);
  if (buybox) {
    const fit = () => {
      const headerH = header?.offsetHeight || 72;
      buybox.style.top = `${Math.min(headerH + 20, innerHeight - buybox.offsetHeight - 20)}px`;
    };
    addEventListener("resize", fit);
    new ResizeObserver(fit).observe(buybox);
  }

  /* delivery estimate */
  const fmtDate = (d) => d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  const addDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
  const [pMin, pMax] = (pdp.dataset.processing || "1,3").split(",").map(Number);
  const [dMin, dMax] = (pdp.dataset.delivery || "10,18").split(",").map(Number);
  const dOrder = $("[data-d-order]", pdp);
  if (dOrder) {
    dOrder.textContent = fmtDate(new Date());
    $("[data-d-ship]", pdp).textContent = `${fmtDate(addDays(pMin))} – ${fmtDate(addDays(pMax))}`;
    $("[data-d-deliver]", pdp).textContent = `${fmtDate(addDays(dMin))} – ${fmtDate(addDays(dMax))}`;
  }

  renderPrice();
})();
